/*
 * @Author: 肖玲
 * @Date: 2023-02-17 15:33:49
 * @LastEditTime: 2023-02-17 15:53:32
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\learning-platform\system-settings\index.js
 * 系统配置
 */
import systemSettingRouter from './modules/systemSettingRouter'
const systemSettingsRouter = [].concat(systemSettingRouter)
export default systemSettingsRouter